import { useId, useMemo, useState } from 'react'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { Checkmark20Regular } from '@/components/Icon'
import { PreferenceFloatingSelectTrigger } from '@/components/Settings/PreferenceFloatingSelectTrigger'
import prefStyles from '@/components/Settings/SettingsPreferenceSection.module.scss'

/** @typedef {{ value: string, label: string }} SelectOption */

/**
 * @param {{ 'aria-label': string, value: string, options: SelectOption[], onChange: (value: string) => void }} props
 */
export function PreferenceFloatingSelect({ 'aria-label': ariaLabel, value, options, onChange }) {
  const listId = useId()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const selectedLabel = useMemo(() => options.find((o) => o.value === value)?.label ?? value, [options, value])
  const menuItems = useMemo(
    () => options.map((o) => ({ id: o.value, label: o.label, ...(o.value === value ? { Icon: Checkmark20Regular } : {}) })),
    [options, value],
  )

  return (
    <>
      <PreferenceFloatingSelectTrigger ariaLabel={ariaLabel} listId={listId} open={open} selectedLabel={selectedLabel} onOpen={setAnchorEl} />
      <FloatingMenuPopup
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        items={menuItems}
        hideBackdrop
        onItemSelect={(id) => onChange(id)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        menuListId={listId}
        menuListAriaLabel={ariaLabel}
        paperClassName={prefStyles.preferenceMenuPaper}
      />
    </>
  )
}
